import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { adminApi, TOKEN_KEY } from "../lib/adminApi";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => (localStorage.getItem(TOKEN_KEY) ? null : false));

  useEffect(() => {
    if (!localStorage.getItem(TOKEN_KEY)) return;
    adminApi.get("/auth/me").then((r) => setUser(r.data)).catch(() => { localStorage.removeItem(TOKEN_KEY); setUser(false); });
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await adminApi.post("/auth/login", { email, password });
    localStorage.setItem(TOKEN_KEY, data.token);
    setUser(data.user);
  }, []);

  const logout = useCallback(() => {
    adminApi.post("/auth/logout").catch(() => {});
    localStorage.removeItem(TOKEN_KEY);
    setUser(false);
  }, []);

  return <AuthContext.Provider value={{ user, login, logout }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
